import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ 
  name: 'friendlyname',
  standalone:false
 })
export class AltFriendlyNamePipe implements PipeTransform {
  transform(str: string, form: string): any {
    if (!str) {
      return str;
    }

    if (form === 'stripHtml') {
      let output = str.replace(/\<.+?\>/g, '');
      output = output.replace(/℠/g, 'SM');
      output = output.replace(/&reg;/g, '®');
      return output;
    }

    if (form == null || form === undefined || form !== 'ada') {
      str = str.replace(/\s/g, '');
      str = str.replace(/®/g, '');
      str = str.replace(/\//g, '');
      str = str.replace(/™/g, '');
      str = str.replace(/\+/g, '');
    }
    
    str = str.replace(/<sup>/g, '');
    str = str.replace(/<\/sup>/g, '');
    str = str.replace(/<sub>/g, '');
    str = str.replace(/<\/sub>/g, '');
    str = str.replace(/&#126;/g, '~');
    return str;
  }
}
